"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MarginOffset = _interopRequireDefault(require("@foundation-lib/ui/src/shared/components/MarginOffset"));

var _StateInput = _interopRequireDefault(require("../inputs/StateInput"));

var _CountryInput = _interopRequireDefault(require("../inputs/CountryInput"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  flex: 1 1 auto;\n  width: 50%;\n  @media (max-width: 650px) {\n    width: 100%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  width: 100%;\n  @media (max-width: 650px) {\n    flex-wrap: wrap;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TwoItemRow = _styledComponents["default"].div(_templateObject());

var Item = _styledComponents["default"].div(_templateObject2());

var _default = function _default(_ref) {
  var TextField = _ref.TextField,
      SelectField = _ref.SelectField,
      OptionComponent = _ref.OptionComponent,
      _ref$CountryInput = _ref.CountryInput,
      CountryInput = _ref$CountryInput === void 0 ? _CountryInput["default"] : _ref$CountryInput,
      _ref$StateInput = _ref.StateInput,
      StateInput = _ref$StateInput === void 0 ? _StateInput["default"] : _ref$StateInput,
      _ref$enableEmail = _ref.enableEmail,
      enableEmail = _ref$enableEmail === void 0 ? false : _ref$enableEmail,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$lockCountry = _ref.lockCountry,
      lockCountry = _ref$lockCountry === void 0 ? false : _ref$lockCountry,
      _ref$lockCountryHelpe = _ref.lockCountryHelperText,
      lockCountryHelperText = _ref$lockCountryHelpe === void 0 ? 'International shipping is unavailable' : _ref$lockCountryHelpe,
      formPath = _ref.formPath;
  var country = data.country;

  var fieldName = function fieldName(name) {
    return formPath ? "".concat(formPath, ".").concat(name) : name;
  };

  return /*#__PURE__*/_react["default"].createElement(_MarginOffset["default"], null, /*#__PURE__*/_react["default"].createElement(TwoItemRow, null, /*#__PURE__*/_react["default"].createElement(Item, null, /*#__PURE__*/_react["default"].createElement(TextField, {
    required: true,
    name: fieldName('name.first'),
    label: "First name",
    width: "full",
    autoComplete: "given-name"
  })), /*#__PURE__*/_react["default"].createElement(Item, null, /*#__PURE__*/_react["default"].createElement(TextField, {
    required: true,
    name: fieldName('name.last'),
    label: "Last name",
    width: "full",
    autoComplete: "family-name"
  }))), enableEmail && /*#__PURE__*/_react["default"].createElement(TextField, {
    required: true,
    name: fieldName('email'),
    label: "Email",
    width: "full",
    autoComplete: "email"
  }), /*#__PURE__*/_react["default"].createElement(TextField, {
    required: true,
    name: fieldName('line1'),
    label: "Address line 1",
    width: "full",
    autoComplete: "address-line1"
  }), /*#__PURE__*/_react["default"].createElement(TextField, {
    name: fieldName('line2'),
    label: "Address line 2",
    width: "full",
    autoComplete: "address-line2"
  }), /*#__PURE__*/_react["default"].createElement(TwoItemRow, null, /*#__PURE__*/_react["default"].createElement(Item, null, /*#__PURE__*/_react["default"].createElement(CountryInput, (0, _extends2["default"])({
    required: true,
    name: fieldName('country'),
    label: "Country",
    width: "full",
    select: true,
    disabled: lockCountry
  }, lockCountry && {
    helperText: lockCountryHelperText
  }, {
    autoComplete: "country",
    OptionComponent: OptionComponent,
    SelectComponent: SelectField
  }))), /*#__PURE__*/_react["default"].createElement(Item, null, /*#__PURE__*/_react["default"].createElement(StateInput, {
    country: country,
    name: fieldName('state'),
    label: "State/Province/Region",
    width: "medium",
    select: true,
    required: true,
    autoComplete: "address-level1",
    OptionComponent: OptionComponent,
    SelectComponent: SelectField
  }))), /*#__PURE__*/_react["default"].createElement(TwoItemRow, null, /*#__PURE__*/_react["default"].createElement(Item, null, /*#__PURE__*/_react["default"].createElement(TextField, {
    required: true,
    name: fieldName('city'),
    label: "City",
    width: "full",
    autoComplete: "address-level2"
  })), /*#__PURE__*/_react["default"].createElement(Item, null, /*#__PURE__*/_react["default"].createElement(TextField, {
    required: true,
    name: fieldName('zip'),
    label: "Zip / Postal code",
    width: "medium",
    autoComplete: "postal-code"
  }))));
};

exports["default"] = _default;